import React from 'react';
import * as moment from 'moment';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import PlanField from 'components/PlanField';
import AlertAlt from 'components/AlertAlt';
import usePlan from 'hooks/usePlan';
import { useTeamContext } from 'contexts/useTeamContext';
import { Card, Title, Separator, PlanFieldContainer } from 'styles/components/planDetailsCard';

export default function MemberPlanDetailsCard() {
  const [team] = useTeamContext();
  const [plan] = usePlan();

  return (
    <Card>
      <Title>Teams & Institutions Member Subscription</Title>
      <Separator />

      {plan?.cancelAt && (
        <Box mt={3}>
          <AlertAlt icon={false} severity="default">
            Your plan has been <b>canceled</b> and will be changed to <b>Starter</b> on{' '}
            {moment.utc(plan.cancelAt).format('MM/DD/YYYY')}
          </AlertAlt>
        </Box>
      )}

      <PlanFieldContainer margin="20px 0">
        <PlanField
          icon="group_work"
          label="Teams & Institutions Group"
          value={team ? team.name : ''}
        />
      </PlanFieldContainer>

      {/* <PlanFieldContainer margin="20px 0">
        <PlanField
          icon="supervisor_account"
          label="Teams & Labs Admin"
          value={
            getTeamAdmin()
            ? <Typography><b>{adminName} (adminEmail)</b></Typography>
            : ''
          }
        />
      </PlanFieldContainer> */}

      {/* <PlanFieldContainer margin="20px 0">
        <PlanField
          icon="people_alt"
          label="Teams & Institutions Members"
          value={
            <>
              {team.invites.map((invite, index) => (
                <Typography key={index}>
                  <b>
                    {invite.name} ({invite.email})
                  </b>
                </Typography>
              ))}
            </>
          }
        />
      </PlanFieldContainer> */}

      {!plan?.cancelAt && (
        <AlertAlt icon={false} severity="default">
          You are a Teams & Institutions subscription member and have all the benefits of it. Enjoy!
        </AlertAlt>
      )}
    </Card>
  );
}
